{
  "replaceMessage": "Largar ficheiro para substituir"
}
